import qs from 'qs';
import serviceEnv from "@/services/env.js";

class Service {
    constructor(portfolioElement) {
        this.config = serviceEnv.config;
        this.portfolioElement = portfolioElement;
        const params = qs.stringify({
            'Key': this.config.serviceKey,
            'Id': this.config.serviceId,
            'Ver': this.config.serviceInfoObjectVersion,
            'EnL': this.config.serviceInfoObjectEncryptionLevel,
            'EnK': this.config.serviceInfoObjectEncryptionKey
        });
        this.url = this.config.serviceUrl + '/' + this.config.servicePortfolioElement + '/info?' + params;
    }
}

export default Service;